import {Controller} from "stimulus"
import $ from 'jquery';
import toastr from 'toastr/toastr'
import bootbox from 'bootbox';
import 'toastr/toastr.scss'

require('leaflet/dist/leaflet.css')
import 'leaflet'
import {OpenStreetMapProvider} from 'leaflet-geosearch'
import {post} from "@rails/request.js";

require("select2/dist/css/select2")
require("select2-bootstrap-theme/dist/select2-bootstrap")

const provider = new OpenStreetMapProvider();

//Variables
let map = '';
let markersLayer = null; // 👈 Capa para limpiar y reemplazar marcadores
let edit_map = '';
// let latlngs = [[23.916, -73.537],
//     [19.421, -86.155]];
let latlngs = [[24.000, -73.619],
    [19.300, -85.590]];

let destination = '';
let daterange = '';
let guestrooms = '';


function getPointData(lat, lng, latlng, addrs = null, popup = null) {
    var reversegeocode = 'https://nominatim.openstreetmap.org/reverse?format=json&lat=' + lat + '&lon=' + lng + '&zoom=18&addressdetails=1'; //alert(reversegeocode);
    $.getJSON(reversegeocode, function (data) {
        var msg = `${data.display_name} <br> <span class="helper_text small">Esta dirección es autogenerada, revise el campo de dirección en el formulario para verificar que sea la correcta.</span>`;
        if (addrs !== null) {
            addrs.value = data.display_name
        }

        if (popup !== null) {
            popup
                .setLatLng(latlng)
                .setContent(msg)
                .openOn(edit_map);
        }


    });
}

export default class extends Controller {
    /*initialize() {
        let vmap = $('#map');
        if (vmap[0] !== undefined) {

            $.ajax({
                url: `${location.origin}/es/admin/hotel/hoteles_map`,
                data: {
                    format: 'json'
                },
                type: 'GET',
                beforeSend: function () {
                    $('#overlay_map_load').html('<h1>Cargando datos... <span class="fa fa-spin fa-spinner"></span></h1>').delay(5000).fadeOut(1000)
                },
                success: function (data) {
                    if (data.total > 0) {
                        let offices = data.rows;
                        //Inicializando mapa
                        map = L.map('map', {
                            zoom: 6.50,
                            minZoom: 6.50,
                            zoomSnap: 0.25,
                            scrollWheelZoom: true,
                            touchZoom: true
                        });
                        map.fitBounds(latlngs);
                        //FUNCTIONS
                        map.on('click', function (event) {
                            $('#info_box').html(`
                                 <span><strong>Longitud:</strong> ${event.latlng.lng}</span><br>
                                 <span><strong>Latitud:</strong> ${event.latlng.lat}</span><br>
                                 ${event.latlng.lat},${event.latlng.lng}
                                `)
                        })
                        //Agregando capa OpenStreetMap
                        L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            attribution: '&copy; LaberintoTech ',
                            maxZoom: 15
                        }).addTo(map);

                        //Control de escala
                        L.control.scale().addTo(map);

                        //MARCADORES E ICONOS
                        var myIcon = L.icon({
                            iconUrl: `${data.pin}`,
                            className: 'pin-map',
                            popupAnchor: [-3, -3],
                            iconSize: [20, 30]
                        });


                        offices.map(elem => {
                            if (elem.latitude !== "0.0" && elem.longitude !== "0.0") {
                                // let open_time = `${elem.open_time}am - ${elem.close_time}pm`;
                                //
                                // if (elem.full_time) {
                                //     open_time = '24 horas';
                                // }

                                L.marker([parseFloat(elem.latitude), parseFloat(elem.longitude)], {
                                    draggable: false,
                                    icon: myIcon,
                                    title: `${elem.name} | Click para ver más detalles...`,
                                    alt: ''
                                }).addTo(map).bindPopup(`<h3>${elem.name}</h3>
                                <br><strong>Dirección:</strong> ${elem.address}`);

                                /!*<br><strong>Telefono:</strong> ${elem.phones}
                                    <br><strong>Horario:</strong> ${open_time}*!/
                            }
                        })

                    }else{
                        let container_map = document.getElementsByClassName('presentation-with-map');
                        let map_id = $('#map')[0];
                        if(document.getElementById(`to_section_${map_id.dataset.id}`) !== null){
                            document.getElementById(`to_section_${map_id.dataset.id}`).style.display = 'none';
                        }
                        if(container_map !== null && container_map !== undefined){

                            container_map[0].classList.add('ocultar');
                        }
                    }
                }
            })


        }

        //EDIT MAP
        if ($('#edit_map')[0] !== undefined) {
            let lat = document.getElementById('latitude');
            let lng = document.getElementById('longitude');
            let addrs = document.getElementById('address');

            edit_map = L.map('edit_map', {
                zoom: 6.50,
                minZoom: 6.50,
                zoomSnap: 0.25,
                scrollWheelZoom: true,
                touchZoom: true
            });

            if ((lat !== null && lng !== null) && (lat.value !== "0.0" && lng.value !== "0.0")) {
                edit_map.setView([parseFloat(lat.value), parseFloat(lng.value)], 15);

                //MARCADORES E ICONOS
                var myIcon = L.icon({
                    iconUrl: '/pin.png',
                    popupAnchor: [-3, -3],
                    iconSize: [20, 30],
                });

                L.marker([parseFloat(lat.value), parseFloat(lng.value)], {
                    draggable: false,
                    icon: myIcon,
                    title: 'Click para ver más detalles...',
                    alt: ''
                }).addTo(edit_map).bindPopup(`<h3>${document.getElementById('name').value}</h3>
                    <br><strong>Telefono:</strong> ${document.getElementById('phones').value}
                    <br><strong>Horario:</strong> ${document.getElementById('open_time').value}
                    <br><strong>Dirección:</strong> ${document.getElementById('address').value}`);
            } else {
                edit_map.fitBounds(latlngs)
            }


            //Agregando capa OpenStreetMap
            L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://cloudmade.com">CloudMade</a>',
                maxZoom: 24
            }).addTo(edit_map);

            // popup para la direccion
            var popup = L.popup();

            edit_map.on('click', function (event) {
                lat.value = event.latlng.lat;
                lng.value = event.latlng.lng;
                getPointData(event.latlng.lat,event.latlng.lng,event.latlng, addrs, popup);

            })

            // addrs.addEventListener('keyup', async function (e) {
            //     const results = await provider.search({ query: e.target.value });
            // })


            lat.addEventListener('keyup', function (e) {
                if((e.target.value !== null && lng !== null) && (e.target.value !== "0.0" && lng.value !== "0.0")){
                   if(!e.target.value.isEmpty() && !lng.value.isEmpty()){
                       edit_map.setView([parseFloat(e.target.value), parseFloat(lng.value)], 15);

                       getPointData(e.target.value, lng.value,{lat: e.target.value, lng: lng.value}, addrs, popup)
                   }
                }
            })

            lng.addEventListener('keyup', function (e) {
                if((e.target.value !== null && lat !== null) && (e.target.value !== "0.0" && lat.value !== "0.0")){
                    if(!e.target.value.isEmpty() && !lat.value.isEmpty()){
                        edit_map.setView([parseFloat(lat.value), parseFloat(e.target.value)], 15);

                        getPointData(lat.value,e.target.value,{lat: lat.value, lng: e.target.value}, addrs, popup)
                    }
                }
            })
        }
    }*/

    connect() {
        if (window.mapInstance) return; // Evitar doble inicialización

        this.overlay = document.getElementById('overlay_map_load');

        /*$('.select_with_clear_hotels').select2({
            theme: "bootstrap",
            language: "es",
            placeholder: "Seleccione una opción",
            allowClear: true
        }).on('select2:select', function () {
            console.info('select2:select');
        }).on('select2:unselecting', function () {
            console.info('select2:unselecting');
        });*/

        /*this.map = L.map('map', {
            zoom: 6.50,
            minZoom: 6.50,
            zoomSnap: 0.25,
            scrollWheelZoom: true,
            touchZoom: true
        });*/
        this.map = L.map('map', {
            zoom: 6.5,
            minZoom: 2,
            zoomSnap: 0.25,
            scrollWheelZoom: true,
            touchZoom: true,
            worldCopyJump: true
        });

        // Centrar en Cuba desde el inicio — NO CAMBIAR ESTO
        this.map.fitBounds([[24.000, -73.619], [19.300, -85.590]]);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; LaberintoTech',
            maxZoom: 19 /* estaba 15 para que se quede en barrio */
        }).addTo(this.map);

        L.control.scale().addTo(this.map);

        this.markersLayer = L.layerGroup().addTo(this.map);
        window.mapInstance = this.map;
        window.mapMarkersLayer = this.markersLayer;

        // Cargar hoteles iniciales
        this.loadInitialHotels();
        this.element.hotetecMapController = this;

        /*this.map.on('moveend zoomend', () => this.handleMapChange());*/
        this.map.on('moveend zoomend', () => this.handleMapChange());
    }

    async loadInitialHotels() {
        try {
            const res = await fetch('/es/admin/hotel/hoteles_map?format=json');
            const data = await res.json();

            if (data.total > 0) {
                this.updateMarkers(data.rows);
            }

            // 👇 Ocultar overlay al terminar de cargar
            if (this.overlay) {
                this.overlay.style.display = 'none';
            }

        } catch (err) {
            console.error("Error al cargar hoteles iniciales", err);
            if (this.overlay) {
                this.overlay.innerHTML = '<h1>Error al cargar datos</h1>';
                setTimeout(() => {
                    this.overlay.style.display = 'none';
                }, 2000);
            }
        }
    }

    updateMarkers(hotels, hotels_rest = [], update_list = false) {
        if (!this.markersLayer) return;

        this.markersLayer.clearLayers();

        // Si no hay hoteles principales, mantenemos el mapa centrado en Cuba
        if (!hotels || hotels.length === 0) {
            const cubaBounds = [[24.000, -73.619], [19.300, -85.590]];
            this.map.fitBounds(cubaBounds, {padding: [50, 50]});
            return;
        }

        const pinUrl = '/pin.png';
        const pinUrlRest = '/pin.png';
        const myIcon = L.icon({
            iconUrl: pinUrl,
            /*iconSize: [20, 30],
            popupAnchor: [-3, -3],*/
            className: 'pin-map',
            iconSize: [44, 44],        // Tamaño mínimo 44x44
            iconAnchor: [22, 44],      // Punto de anclaje centrado
            popupAnchor: [0, -44]      // Posición del popup
        });
        /*const myIconRest = L.icon({
            iconUrl: pinUrlRest,
            iconSize: [15, 25],
            popupAnchor: [-3, -3],
            className: 'pin-map'
        });*/
        // const myIcon = createPin('#E9501CD6'); // rojo
        const myIconRest = createPin('#273746'); // gris

        // Filtrar solo hoteles dentro de Cuba (opcional)
        /*const cubaBounds = [[24.000, -73.619], [19.300, -85.590]];
        const cubaHotels = hotels.filter(hotel => {
            const lat = parseFloat(hotel.latitude);
            const lng = parseFloat(hotel.longitude);
            return lat >= 19.3 && lat <= 24.0 && lng >= -85.59 && lng <= -73.619;
        });*/

        // 🗺️ Dibujar los hoteles principales (filtrados)
        hotels.forEach(hotel => {
            const marker = L.marker(
                [parseFloat(hotel.latitude), parseFloat(hotel.longitude)],
                {icon: myIcon}
            ).bindPopup(`<h3 style="margin-bottom: 0 !important;">${hotel.name}</h3>
                        ${hotel.estrellas}
                        ${(hotel.rates) ? `<br><strong>Tarifas:</strong> ${hotel.rates}` : ''}
                        <br><strong>Dirección:</strong> ${hotel.address}
                        <br><strong>Código Postal:</strong> ${hotel.postal_code}
                        <br><a data-action="click->setValue#saltarA" data-target="#card-hotel-${hotel.id}" class="btn btn-info hotel-card-container-btn d-block d-md-none" style="width: fit-content; margin-top: .5rem; color: white;">
                                <i class="fa fa-map-marker"></i> Hotel
                            </a>`);
            this.markersLayer.addLayer(marker);
        });

        // 🧩 Crear una capa separada para los "otros" hoteles
        if (!this.restMarkersLayer) {
            this.restMarkersLayer = L.layerGroup().addTo(this.map);
        } else {
            this.restMarkersLayer.clearLayers();
        }

        hotels_rest.forEach(hotel => {
            const marker = L.marker(
                [parseFloat(hotel.latitude), parseFloat(hotel.longitude)],
                {icon: myIconRest}
            ).bindPopup(`<h3 style="margin-bottom: 0 !important;">${hotel.name}</h3>
                        ${hotel.estrellas}
                        ${(hotel.rates) ? `<br><strong>Tarifas:</strong> ${hotel.rates}` : ''}
                        <br><strong>Dirección:</strong> ${hotel.address}
                        <br><strong>Código Postal:</strong> ${hotel.postal_code}
                        <br><a data-action="click->setValue#saltarA" data-target="#card-hotel-${hotel.id}" class="btn btn-info hotel-card-container-btn d-block d-md-none" style="width: fit-content; margin-top: .5rem; color: white;">
                                <i class="fa fa-map-marker"></i> Hotel
                            </a>`);
            this.restMarkersLayer.addLayer(marker);
        });

        // 👇 Solo centramos el mapa en los hoteles principales (los del filtro)
        const group = new L.featureGroup([...this.markersLayer.getLayers()]);
        this.map.fitBounds(group.getBounds(), {padding: [50, 50]});

        /*if (update_list) {
            this.map.on('moveend zoomend', () => this.handleMapChange());
        }*/
    }

    /* Para tratar cuando se hace zoom en el mapa y envíar petición para tratarlos y rellenar el partial de la lista de hoteles */
    async handleMapChange() {
        // 📍 Obtener límites visibles del mapa
        const bounds = this.map.getBounds();

        post(`/admin/hotel/reservas2_search_hotel`, {
            query: {
                north: bounds.getNorth(),
                south: bounds.getSouth(),
                east: bounds.getEast(),
                west: bounds.getWest(),
                destination: $('#destination').val(),
                dateRange: $('#date_range').val(),
                guests: $('#guests_rooms').val()
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            /*this.isLogin(r);
            this.setDealerData()*/
            console.log("Lista de Hoteles actualizada satisfactoriamente.");
        });
    }

    isLogin(r) {
        if (r.responseText && typeof r.responseText.then === 'function') {
            r.responseText.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        }
        if (r.response && typeof r.response.then === 'function') {
            r.response.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        } else {
            if (r.response.url.includes("login")) {
                window.location.href = r.response.url;
            }
        }
    }
}

function createPin(color = '#c0392b') {
    const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 512 512">
      <path fill="${color}" d="M256 0C156.698 0 76 80.698 76 180c0 123.598 180 332 180 332s180-208.402 180-332C436 80.698 355.302 0 256 0z"/>
      <circle fill="white" cx="256" cy="180" r="80"/>
    </svg>`;
    return L.divIcon({
        html: svg,
        className: 'pin-map-svg',
        iconSize: [30, 40],
        popupAnchor: [0, -10]
    });
}

